import { Controller } from "@hotwired/stimulus"
import type { TurboSubmitEndEvent } from "@hotwired/turbo"

export default class ListController extends Controller {
  declare modalTarget: HTMLElement

  static targets = ["modal"]

  handleSubmitEnd(event: TurboSubmitEndEvent): void {
    if (event.detail.success) {
      const modal = globalThis.bootstrap.Modal.getInstance(this.modalTarget)
      modal?.hide()
    }
  }
}
